;(function () {
  'use strict'

  angular.module('contrast.agent-languages').constant('LEGACY_AGENT_LANGUAGE', {
    JAVA: ['Java'],
    DOTNET: ['.NET', 'dotnet'],
    DOTNET_CORE: ['.NET Core', 'dotnet_core'],
    NODE: ['Node'],
    RUBY: ['Ruby'],
    PROXY: ['Proxy'],
    PYTHON: ['Python'],
    PHP: ['PHP'],
    GO: ['Go']
  })
})()
